export enum StatisticType {
  BLOCK = 'BLOCK',
  ENTITY = 'ENTITY',
  ITEM = 'ITEM',
  UNTYPED = 'UNTYPED',
}
